import React, { useContext, useEffect, useState, Fragment } from "react";
import { Container, Accordion, Icon } from "semantic-ui-react";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import { observer } from "mobx-react-lite";
import { IVariation } from "../../../../app/models/variation";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";

interface IProps {}

const WorkOrderSORSGrid: React.FC<IProps> = () => {
  const [activeIndex, setActiveIndex] = useState();
  const workorderStore = useContext(WorkOrderStore);
  const { selectedWorkOrderVariations: workorderVariations } = workorderStore;

  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const getAppStatusColour = (st: string) => {
    if (st === "Approved" || st === "Auto Approved")
      return <Icon name="check circle" color="green" size="small" />;
    if (st === "Rejected")
      return <Icon name="times circle" color="red" size="small" />;
    if (st === "Awaiting Approval")
      return <Icon name="stopwatch" size="small" />;
  };

  const SorCols = [
    {
      headerName: "Description",
      field: "SORDescripion",
      width: 420,
      suppressSizeToFit: true
    },
    { headerName: "Qty", field: "SORQty", width: 75, suppressSizeToFit: true },
    {
      headerName: "SOR",
      field: "SORCode",
      width: 100,
      suppressSizeToFit: true,
      resizable: true
    },
    
    {
      headerName: "Value",
      field: "SORValue",
      valueFormatter: currencyFormatter,
      width: 150,
      resizable: true
    
    }
    ,
    {
      headerName: "Requestor Comments",
      field: "VarComment",
      width: 200,
      resizable: true
    }
    ,
    {
      headerName: "Approver Comments",
      field: "DeclineReason",
      width: 200,
      resizable: true
    },
    {
      headerName: "Approved / Declined By",
      field: "ApprovedDeclinedBy",
      width: 200,
      resizable: true
    }
  ];

  function currencyFormatter(params: any) {
    return "\xA3" + params.value.toFixed(2);
  }

  const showVariationHistory = (vars: IVariation[]) => {
    if (vars !== null) {
      var varHist = vars.map((vr, index) => (
        <Fragment>
          <Accordion.Title
            active={activeIndex === index}
            index={index}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            {getAppStatusColour(vr.AppStatus)} <b> {vr.Name} </b>  
            <div style={{ float: "right" }}>
              <Icon name="pound sign" />
              {vr.Value}
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <div
              className="ag-theme-material"
              style={{ height: "200px", width: "100%" }}
            >
              <AgGridReact columnDefs={SorCols} rowData={vr.VarSors} />
            </div>
          </Accordion.Content>
        </Fragment>
      ));

      return varHist;
       }};

  useEffect(() => {
    if (workorderVariations.length !== null) {
      showVariationHistory(workorderVariations);
    }
  },[workorderVariations]);

  return (
    <Container>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <Accordion fluid styled>
          {showVariationHistory(workorderVariations)}
        </Accordion>
      </div>
    </Container>
  );
};

export default observer(WorkOrderSORSGrid);
